// Evaluation Report status helpers

export const EVALUATION_REPORT_STATUSES = [
  'Pending',
  'Approved by VC-RDES',
  'Rejected by VC-RDES',
  'Approved by Chancellor',
  'Rejected by Chancellor'
];

export const getEvaluationReportStatusVariant = (status) => {
  switch (status) {
    case 'Approved by VC-RDES':
    case 'Approved by Chancellor':
      return 'success';
    case 'Rejected by VC-RDES':
    case 'Rejected by Chancellor':
      return 'danger';
    case 'Pending':
    default:
      return 'warning';
  }
};

export const getEvaluationReportStatusDisplayText = (status) => {
  const map = {
    'Pending': 'Pending',
    'Approved by VC-RDES': 'Approved by VC for RDES',
    'Rejected by VC-RDES': 'Rejected by VC for RDES',
    'Approved by Chancellor': 'Approved by Chancellor',
    'Rejected by Chancellor': 'Rejected by Chancellor'
  };
  return map[status] || status || 'Pending';
};


